import {
  GET_USERS_BY_OUTLET_FAILD,
  GET_USERS_BY_OUTLET_LOADING,
  GET_USERS_BY_OUTLET_SUCCESS,
} from "../types";

const initialState = {
  users: null,
  loading: null,
  error: null,
};

export const getUsersByOutletId = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_USERS_BY_OUTLET_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_USERS_BY_OUTLET_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        users: action.payload,
      };
    case GET_USERS_BY_OUTLET_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
